import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.array.find-index";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.array.find";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import debounce from 'lodash/debounce';
import { cloneDeep } from 'lodash';
import get from 'lodash/get';
export default {
  name: 'CustomMultiSearch',
  props: {
    dense: {
      type: Boolean,
      default: false,
      required: false
    },
    searchTypes: {
      type: Array,
      required: true
    },
    searchItems: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    singleSearch: {
      type: Boolean,
      required: false,
      default: false
    },
    defaultSearchType: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    showOperatorDropdown: {
      type: Boolean,
      required: false,
      default: false
    },
    operator: {
      type: String,
      required: false,
      default: 'AND'
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      modelSearchType: '',
      modelSearchFor: '',
      modelSearchKey: '',
      searchTags: [],
      searchOperator: this.operator,
      customSearchInput: '',
      customSearchResult: [],
      customSearchResultLoading: false,
      customSearchSelectedItemCopy: null,
      customSearchPageSize: 50,
      customSearchHasMore: true,
      isIntersecting: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    disableAddSearch: function disableAddSearch() {
      return !(this.modelSearchType !== '' && this.modelSearchFor !== '');
    },
    cols: function cols() {
      var hasKey = this.modelSearchType.param === 'keyValue';
      return {
        category: {
          cols: hasKey ? 4 : 6,
          md: hasKey ? 4 : 2,
          lg: 3
        },
        keyBox: {
          cols: hasKey ? 3 : 0,
          md: hasKey ? 4 : 0,
          lg: hasKey ? 2 : 0
        },
        searchBox: {
          cols: hasKey ? 5 : 6,
          md: hasKey ? 4 : 6,
          lg: hasKey ? 3 : 4
        },
        displayBox: {
          cols: 12,
          md: hasKey ? 12 : 4,
          lg: hasKey ? 4 : 5
        }
      };
    },
    searchOperators: function searchOperators() {
      return [{
        text: this.$i18n_t('Common.searchOperator.AND'),
        param: 'AND'
      }, {
        text: this.$i18n_t('Common.searchOperator.OR'),
        param: 'OR'
      }];
    },
    useCustomSearch: function useCustomSearch() {
      var searchHandlerType = _typeof(this.modelSearchType.searchHandler);

      return searchHandlerType === 'function';
    },
    customSearchResultWithSelected: function customSearchResultWithSelected() {
      var _this = this;

      var items = [];

      if (this.customSearchResult.pages && this.customSearchResult.pages.length) {
        items = cloneDeep(this.customSearchResult.pages.flat());
      }

      if (this.customSearchSelectedItemCopy) {
        items.push(this.customSearchSelectedItemCopy);
      } // unique by id


      return items.map(function (item, index) {
        return _objectSpread(_objectSpread({}, item), {}, {
          __doIntersect__: index >= items.length - _this.customSearchPageSize / 2
        });
      });
    }
  }),
  watch: {
    searchTypes: function searchTypes() {
      var store = this.modelSearchType.param;
      this.modelSearchType = this.searchTypes.find(function (item) {
        return item.param === store;
      }) || {};
    },
    searchItems: function searchItems() {
      this.searchTags = this.searchItems;
    },
    operator: function operator() {
      var _this2 = this;

      this.searchOperator = this.searchOperators.filter(function (item) {
        return item.param === _this2.operator;
      })[0] || {};
    },
    customSearchInput: {
      immediate: true,
      handler: function handler() {
        this.resetCustomSearch();
        this.executeCustomSearch();
      }
    },
    modelSearchFor: function modelSearchFor(value) {
      if (this.useCustomSearch) {
        this.customSearchSelectedItemCopy = cloneDeep(value);
      }
    },
    modelSearchType: function modelSearchType() {
      this.resetCustomSearch();
      this.executeCustomSearch();
    },
    isIntersecting: function isIntersecting() {
      if (!this.customSearchResultLoading) {
        this.executeCustomSearch();
      }
    },
    customSearchResultLoading: function customSearchResultLoading() {
      if (this.isIntersecting) {
        this.executeCustomSearch();
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.searchTags = this.searchItems;
    this.modelSearchType = isEmpty(this.defaultSearchType) ? '' : this.defaultSearchType;

    if (this.searchOperators.length > 0) {
      this.searchOperator = this.searchOperators.filter(function (item) {
        return item.param === _this3.operator;
      })[0] || {};
    }
  },
  methods: {
    resetCustomSearch: function resetCustomSearch() {
      this.customSearchResult = {
        total: 0,
        hasMore: true,
        pages: []
      };
    },
    executeCustomSearch: debounce( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var previouslyFetchedPages, pageToFetch, fetchedItems, allPreviouslyFetchedItems, allFetchedItems, hasMore;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this.useCustomSearch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              if (!this.customSearchResultLoading) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              if (this.customSearchResult.hasMore) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return");

            case 6:
              this.customSearchResultLoading = true;
              _context.prev = 7;
              previouslyFetchedPages = get(this.customSearchResult, 'pages', []);
              pageToFetch = previouslyFetchedPages.length;
              _context.next = 12;
              return this.modelSearchType.searchHandler(this.customSearchInput, pageToFetch, this.customSearchPageSize);

            case 12:
              fetchedItems = _context.sent;
              allPreviouslyFetchedItems = previouslyFetchedPages.flat();
              allFetchedItems = [].concat(_toConsumableArray(allPreviouslyFetchedItems), _toConsumableArray(fetchedItems.items));
              hasMore = fetchedItems.totalCount > allFetchedItems.length;
              this.customSearchResult = {
                total: fetchedItems.totalCount,
                hasMore: hasMore,
                pages: [].concat(_toConsumableArray(previouslyFetchedPages), [fetchedItems.items])
              };
              this.isIntersecting = false;
              _context.next = 24;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](7);
              console.error(_context.t0);
              this.$snack(this.$i18n_t('Common.multisearch.customSearch.error'), 'error');

            case 24:
              _context.prev = 24;
              this.customSearchResultLoading = false;
              return _context.finish(24);

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[7, 20, 24, 27]]);
    })), 300),
    updateSearchType: function updateSearchType() {
      this.modelSearchFor = '';
      this.modelSearchKey = '';
    },
    searchKeyUpEnter: function searchKeyUpEnter() {
      if (!this.disableAddSearch) {
        this.searchAdd();
      }
    },
    parentTwinSelected: function parentTwinSelected(parentTwin) {
      this.modelSearchFor = parentTwin ? {
        value: parentTwin.id,
        text: parentTwin.title
      } : undefined;
      this.searchAdd();
    },
    searchRemove: function searchRemove(searchItemIndex) {
      this.searchTags.splice(searchItemIndex, 1);
      this.updateSearchType();
      this.$emit('updated', this.searchTags, this.searchOperator.param);
    },
    searchOperatorUpdate: function searchOperatorUpdate() {
      this.searchTags.splice(0, this.searchTags.length);
      this.updateSearchType();
      this.$emit('updated', this.searchTags, this.searchOperator.param);
    },
    searchAdd: function searchAdd() {
      var type = this.modelSearchType.text;
      var param = this.modelSearchType.param; // make sure that >null< is supported and not written as string "null" via `${text}`.trim()

      var searchForText = (this.modelSearchFor || {}).text !== undefined ? this.modelSearchFor.text : this.modelSearchFor;
      searchForText = searchForText === null ? searchForText : "".concat(searchForText).trim();
      var search = (this.modelSearchFor || {}).text ? {
        value: this.modelSearchFor.value,
        text: searchForText
      } : searchForText; // If the to be added search already exists in `searchTags` ignore it

      var index = this.searchTags.findIndex(function (item) {
        return item.param === param && item.search === search;
      });

      if (index > -1) {
        this.updateSearchType();
        return;
      }

      var key = param === 'keyValue' ? "".concat(this.modelSearchKey).trim() : undefined;
      this.searchTags.push({
        type: type,
        param: param,
        search: search,
        key: key
      });
      this.updateSearchType();
      this.$emit('updated', this.searchTags, this.searchOperator.param);
    },
    endCustomSearchIntersect: function () {
      var _endCustomSearchIntersect = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(entries, observer, isIntersecting) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (isIntersecting) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                this.isIntersecting = true;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function endCustomSearchIntersect(_x, _x2, _x3) {
        return _endCustomSearchIntersect.apply(this, arguments);
      }

      return endCustomSearchIntersect;
    }()
  }
};